
// src/PrivateRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import LocalStorageService from "./services/LocalStorageService";
import Box from './components/simple/box/Box';

const PrivateRoute = ({ children }) => {
  const isAuthenticated = !!LocalStorageService.get("apiToken");

  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location }}
      />
    );
  }

  return (
    <Box direction='column' alignSelf='start' height="auto" width="100%">
      {children}
    </Box>
  );
};
export default PrivateRoute;
